import { ListingCarGrid } from "@/components/car-listing/listing-car-grid";
import type { ListingCarCardData } from "@/components/car-listing/listing-car-types";
import { useFavoriteToggle } from "@/hooks/use-favorite-toggle";
import type { ReactNode } from "react";

type Props = {
  cars: ListingCarCardData[] | undefined;
  isLoading: boolean;
  isError?: boolean;
  errorMessage?: string;
  onRetry?: () => void;
  emptyExtra?: ReactNode;
};

export function BidderCarGridSection(props: Props) {
  const { favoriteCarIds, toggleFavorite } = useFavoriteToggle();

  return (
    <ListingCarGrid
      cars={props.cars}
      isLoading={props.isLoading}
      isError={props.isError}
      errorMessage={props.errorMessage}
      onRetry={props.onRetry}
      favoriteCarIds={favoriteCarIds}
      onToggleFavorite={toggleFavorite}
      emptyExtra={props.emptyExtra}
    />
  );
}
